// extracted by mini-css-extract-plugin
export default {"customfileupload":"FileSelect_customfileupload__nOId7"};